export const TELEPHONE_REQUEST = "TELEPHONE_REQUEST";
export const TELEPHONE_SUCCESS = "TELEPHONE_SUCCESS";
export const TELEPHONE_FAIL = "TELEPHONE_FAIL";
